<div class="checkout-container">
  <div class="checkout-main">
    @if (deliveryMode === 'pickUp') {
      <div class="checkout-left-section-pickup">
        <div class="checkout-section">
          <div class="section-header" id="pickup-person-header" [ngClass]="{ 'section-disabled': disableAllAccordions || !isStepEnabled(0) }">
            <h2 class="section-title">
              <span class="section-number">1</span>
              Pickup Person
            </h2>
            @if (showPickupPersonEdit) {
              <div>
                <button class="edit-btn" id="edit-pickup-person" (click)="goToCheckoutPage(pickupPersonRoute)">Edit</button>
                <!-- <span class="section-dropdown-icon">▲</span> -->
                <span class="section-dropdown-icon">▼</span>
              </div>
            }
          </div>
          @if (isRouteMatch(pickupPersonRoute)) {
            <div id="pickup-store-body">
              <cx-page-slot position="CwtBodyContent"></cx-page-slot>
            </div>
          }
        </div>
        <div class="checkout-section">
          <div class="section-header" id="store-pickup-header" [ngClass]="{ 'section-disabled': disableAllAccordions || !isStepEnabled(1) }">
            <div class="wrap-text">
              <h2 class="section-title section-store ">
                <span class="section-number">2</span>
                Store Pickup
              </h2>
              @if (selectedDate) {
                <div class="selected-date">
                  - {{selectedDate}}
                </div>
              }
            </div>
            @if (showPickupStoreEdit) {
              <div class="edit-res">
                <button class="edit-btn" id="edit-store-pickup" (click)="goToCheckoutPage(pickupStoreRoute)">Edit</button>
                <!-- <span class="section-dropdown-icon">▲</span> -->
                <span class="section-dropdown-icon">▼</span>
              </div>
            }
          </div>
          @if (isRouteMatch(pickupStoreRoute)) {
            <div id="pickup-store-body">
              <cx-page-slot position="CwtBodyContent"></cx-page-slot>
            </div>
          }
        </div>
        <div class="checkout-section">
          <div class="section-header" id="store-payment-header" [ngClass]="{ 'section-disabled': disableAllAccordions || !isStepEnabled(2) }">
            <h2 class="section-title">
              <span class="section-number">3</span>
              Payment Method
            </h2>
            @if (showPaymentEdit) {
              <div>
                <button class="edit-btn" id="edit-pickup-payment" (click)="goToCheckoutPage(pickupPayment)">Edit</button>
                <!-- <span class="section-dropdown-icon">▲</span> -->
                <span class="section-dropdown-icon">▼</span>
              </div>
            }
          </div>
          <p class="section-subtitle">Choose your preferred payment method</p>
          @if (isRouteMatch(pickupPayment)) {
            <div id="pickup-payment-body">
              <cx-page-slot position="CwtBodyContent"></cx-page-slot>
            </div>
          }
        </div>
      </div>
    }

    @if (deliveryMode === 'delivery') {
      <div class="checkout-left-section-delivery">
        <div class="checkout-section">
          <div class="section-header" id="delivery-address" [ngClass]="{ 'section-disabled': disableAllAccordions || !isStepEnabled(0) }">
            <h2 class="section-title">
              <span class="section-number">1</span>
              Delivery address
            </h2>
            @if (showAddressEdit) {
              <div>
                <button class="edit-btn" id="edit-delivery-address"
                (click)="goToCheckoutPage(deliveryAddressRoute)">Edit</button>
                <!-- <span class="section-dropdown-icon">▲</span> -->
                <span class="section-dropdown-icon">▼</span>
              </div>
            }
          </div>
          @if (isRouteMatch(deliveryAddressRoute)) {
            <div id="delivery-address-body">
              <cx-page-slot position="CwtBodyContent"></cx-page-slot>
            </div>
          }
        </div>
        <div class="checkout-section">
          <div class="section-header" id="schedule-delivery" [ngClass]="{ 'section-disabled': disableAllAccordions || !isStepEnabled(1) }">
            <div class="wrap-text">
              <h2 class="section-title">
                <span class="section-number">2</span>
                Schedule Delivery
              </h2>
              @if (selectedDate) {
                <div class="selected-date-display">
                - {{selectedDate}}</div>
              }
            </div>
            @if (showScheduleEdit) {
              <div>
                <button class="edit-btn" id="edit-schedule-delivery"
                (click)="goToCheckoutPage(scheduleDeliveryRoute)">Edit</button>
                <!-- <span class="section-dropdown-icon">▲</span> -->
                <span class="section-dropdown-icon">▼</span>
              </div>
            }
          </div>
          @if (isRouteMatch(scheduleDeliveryRoute)) {
            <div id="delivery-schedule-body">
              <cx-page-slot position="CwtBodyContent"></cx-page-slot>
            </div>
          }
        </div>
        <div class="checkout-section">
          <div class="section-header" id="delivery-instructions" [ngClass]="{ 'section-disabled': disableAllAccordions || !isStepEnabled(2) }">
            <h2 class="section-title">
              <span class="section-number">3</span>
              Delivery Instructions
            </h2>
            @if (showInstructionsEdit) {
              <div>
                <button class="edit-btn" id="edit-delivery-instructions"
                (click)="goToCheckoutPage(deliveryInstructionsRoute)">Edit</button>
                <!-- <span class="section-dropdown-icon">▲</span> -->
                <span class="section-dropdown-icon">▼</span>
              </div>
            }
          </div>
          @if (isRouteMatch(deliveryInstructionsRoute)) {
            <div id="delivery-instructions-body">
              <cx-page-slot position="CwtBodyContent"></cx-page-slot>
            </div>
          }
        </div>
        <div class="checkout-section">
          <div class="section-header" id="delivery-payment-method" [ngClass]="{ 'section-disabled': disableAllAccordions || !isStepEnabled(3) }">
            <h2 class="section-title">
              <span class="section-number">4</span>
              Payment Method
            </h2>
            @if (showPaymentEdit) {
              <div>
                <button class="edit-btn" id="edit-delivery-payment"
                (click)="goToCheckoutPage(deliveryPaymentRoute)">Edit</button>
                <!-- <span class="section-dropdown-icon">▲</span> -->
                <span class="section-dropdown-icon">▼</span>
              </div>
            }
          </div>
          @if (isRouteMatch(deliveryPaymentRoute)) {
            <div id="delivery-payment-body">
              <cx-page-slot position="CwtBodyContent"></cx-page-slot>
            </div>
          }
        </div>
      </div>
    }
  </div>
  <div class="order-summary-section">
    <cx-page-slot position="CwtSideContent"></cx-page-slot>
  </div>
</div>